<script lang="ts">
  import { setCountry, userSelectedCountryStore } from '../lib/stores/country';
  import { campaignCountries, type SupportedCountryCode } from '../lib/constants/countries';
  import { copy } from '../lib/stores/copy';
  import { getRegionNativeName } from '../lib/helpers/language';
  import { set as setLanguage } from '../lib/stores/language';
  import { isPrimaryCampaign } from '../lib/constants/countries';

  const setTempLanguage = (country: SupportedCountryCode) => {
    if (isPrimaryCampaign) {
      setLanguage(country === "MX" ? "es" : "en");
    }
  }

  let selectedCountry: SupportedCountryCode | null = null;
</script>

{#if !$userSelectedCountryStore}
  <div class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
    <div class="bg-[#1a1a1a] border border-[#333] rounded-lg p-8 max-w-md w-full mx-4">
      <div class="text-center mb-8">
        <h2 class="text-3xl font-MrEavesXLSanNarOTUltra font-black text-primary mb-6 uppercase">
          {$copy.countrySelector.title}
        </h2>
      </div>
      
      <div class="space-y-6">
        <div class="relative">
          <select
            bind:value={selectedCountry}
            class="w-full p-4 bg-[#2a2a2a] border border-[#333] rounded-lg bg-grey text-base appearance-none cursor-pointer focus:border-primary focus:outline-none"
            class:text-gray-400={!selectedCountry}
            class:text-white={selectedCountry}
            on:change={() => selectedCountry && setTempLanguage(selectedCountry)}
          >
            <option value={null} disabled selected class="text-gray-400">
              {$copy.countrySelector.placeholder}
            </option>
            {#each campaignCountries as countryCode}
              <option value={countryCode} class="bg-[#2a2a2a] text-white">
                {$getRegionNativeName(countryCode)}
              </option>
            {/each}
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
        
        <button
          on:click={() => selectedCountry && setCountry(selectedCountry)}
          disabled={!selectedCountry}
          class="std-button font-MrEavesXLSanNarOTUltra relative inline-flex justify-center items-center text-[18px] text-white px-[32px] uppercase h-[48px] w-full bg-dark border-solid border-white border-2 no-underline uppercase transition cursor-pointer overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span class="relative z-[1] leading-[1]">
            {$copy.countrySelector.confirmButton}
          </span>
        </button>
      </div>
    </div>
  </div>
{/if}
